import { render } from "./media-pager.vue?vue&type=template&id=70e1a1ba&scoped=true&ts=true"
import script from "./media-pager.vue?vue&type=script&setup=true&lang=ts"
export * from "./media-pager.vue?vue&type=script&setup=true&lang=ts"

import "./media-pager.vue?vue&type=style&index=0&id=70e1a1ba&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70e1a1ba"],['__file',"src/components/media-pager.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70e1a1ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70e1a1ba', __exports__)) {
    console.log('reload')
    api.reload('70e1a1ba', __exports__)
  }
  
  module.hot.accept("./media-pager.vue?vue&type=template&id=70e1a1ba&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('70e1a1ba', render)
  })

}


export default __exports__